import React from "react";
import { Tooltip as AntTooltip } from "antd";

/*
    Props:
        - message: string   
        - position: string (top, right, bottom, left)
        - children: node
*/

const Tooltip = ({ message, position = "top", children }) => {
  return (
    <AntTooltip title={message} placement={position}>
      <span className="cursor-pointer">{children}</span>
    </AntTooltip>
  );
};

export default Tooltip;
